import type { Priority } from '@voll-intelligence/domain';

import { t } from '@web/i18n';

import { ToneChip, type ToneChipIcon, type ToneChipTone } from './tone_chip';

const MAP: Record<
  Priority,
  { tone: ToneChipTone; icon: ToneChipIcon; labelKey: Parameters<typeof t>[0] }
> = {
  urgent: { tone: 'red', icon: 'caret-double-up', labelKey: 'triage.priority.urgent' },
  high: { tone: 'amber', icon: 'caret-up', labelKey: 'triage.priority.high' },
  normal: { tone: 'gray', icon: 'equals', labelKey: 'triage.priority.normal' },
  low: { tone: 'gray', icon: 'caret-down', labelKey: 'triage.priority.low' },
};

/** Priority pill — domain `Priority` rendered as a tone chip. */
export function PriorityBadge({ priority }: Readonly<{ priority: Priority }>): React.JSX.Element {
  const { tone, icon, labelKey } = MAP[priority];
  return (
    <ToneChip tone={tone} icon={icon}>
      {t(labelKey)}
    </ToneChip>
  );
}
